// Production shop id's that are used to implement location specific features.
export const shopIds = {
  MALMO: '5852d4ef20ff17366fcb6cf4',
  GOBOAT_CANAL_TOURS: '673c5f4eac6302f858f1c83f',
};
